import React, { useEffect, useState } from 'react';
import { CnLayoutBlock as UICnLayoutBlock } from '@cainiaofe/cn-ui';
import isPlainObject from 'lodash/isPlainObject';
import { useFooterAutoWidth } from '../common/hook/useFooterAutoWidth';
import { emitEvent, CnSectionCalculateLayout } from '@/common/util/event-name';
import classNames from 'classnames';
import { executeFunction, isArrayNotEmpty, makeButtons, } from '@/common/util/util';
import { ButtonPosition } from '@/common/manager/position/button-position';
import './view.scss';
const { CnPageFooter, CnButton, CnIcon } = window?.CNUI || {};
const CnLayoutBlock = (props) => {
    const { children, handleProps, _context, buttons, _nodeId, hidden, title, foldable, _unsafe_MixedSetter_buttons_select, className = '', extraDom, ...rest } = props || {};
    const state = _context?.state;
    const footerId = `block-footer-${_nodeId}`;
    const containerId = `block-${_nodeId}`;
    const [isFold, setIsFold] = useState(false);
    const toggleOpen = () => {
        UICnLayoutBlock.updateCacheFoldStore(_nodeId, !isFold);
        setIsFold(!isFold);
    };
    useFooterAutoWidth({
        footerId,
        containerId,
        hidden,
    });
    useEffect(() => {
        if (hidden !== undefined) {
            emitEvent(CnSectionCalculateLayout, {
                _nodeId,
            });
        }
    }, [props?.hidden]);
    // 监听折叠状态变化，触发重新计算布局
    useEffect(() => {
        emitEvent(CnSectionCalculateLayout, {
            _nodeId,
        });
    }, [isFold]);
    if (hidden === true) {
        return null;
    }
    let extraProps = {
        id: containerId,
        ...rest,
    };
    if (typeof handleProps === 'function') {
        const tempProps = executeFunction(handleProps, { ...extraProps }, _context?.state);
        if (isPlainObject(tempProps)) {
            extraProps = tempProps;
        }
    }
    let buttonDom = null;
    const isSlot = _unsafe_MixedSetter_buttons_select === 'SlotSetter';
    if (isArrayNotEmpty(buttons) || isSlot || foldable) {
        buttonDom = (<CnPageFooter id={footerId} style={{
                position: 'fixed',
                bottom: 0,
                zIndex: 1,
            }} mode={'block'} leftSlot={foldable && CnButton ? (<CnButton onClick={toggleOpen} className="cn-layout-block-fold-button">
              <CnIcon type={'arrow-double-left'}/>
            </CnButton>) : null} rightSlot={isSlot
                ? buttons
                : makeButtons?.({
                    buttons: buttons?.map((item) => {
                        return {
                            ...item,
                            position: ButtonPosition.blockButton,
                        };
                    }),
                    _context,
                    state,
                    recordDataSource: {},
                })}/>);
    }
    return (<>
      <div className={classNames({
            'cn-layout-block-toggle-container': true,
            'cn-layout-block-toggle-container-fold': isFold,
        })} onClick={toggleOpen}>
        <div className="cn-layout-block-toggle-button"/>
      </div>
      <UICnLayoutBlock {...extraProps} className={classNames(className, {
            'cn-layout-block-fold': isFold,
        })}>
        {extraDom}
        {children}
        {buttonDom}
      </UICnLayoutBlock>
    </>);
};
CnLayoutBlock.typeMark = 'Block';
CnLayoutBlock.displayName = 'CnLayoutBlock';
export default CnLayoutBlock;
export { CnLayoutBlock };
